"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _closeDefault = _interopRequireDefault(require("@teladoc/pulse/icons/close-default.svg"));
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _ChipModule = _interopRequireDefault(require("./Chip.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["id", "classNameRoot", "classNameItem", "classNameContainer", "classNameLabel", "classNameIcon", "classNameDismiss", "testAttrRoot", "testAttrItem", "testAttrContainer", "testAttrLabel", "testAttrIcon", "testAttrDismiss", "label", "icon", "iconPosition", "name", "value", "defaultChecked", "checked", "disabled", "required", "showDismiss", "onInvalid", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Chip = _ref => {
  let {
      id,
      classNameRoot,
      classNameItem,
      classNameContainer,
      classNameLabel,
      classNameIcon,
      classNameDismiss,
      testAttrRoot,
      testAttrItem,
      testAttrContainer,
      testAttrLabel,
      testAttrIcon,
      testAttrDismiss,
      label,
      icon,
      iconPosition,
      name,
      value,
      defaultChecked,
      checked,
      disabled,
      required,
      showDismiss,
      onInvalid,
      onChange
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    setValidationState,
    isValid,
    ref
  } = (0, _useValidation.default)({
    id,
    onInvalid
  });
  const {
    'aria-invalid': isAriaInvalid
  } = rest;
  const onInvalidCallback = evt => {
    evt.preventDefault();
  };
  const onChanged = evt => {
    setValidationState(null);
    if (onChange) {
      onChange(evt);
    }
  };
  (0, _react.useEffect)(() => {
    // when this is used in a multi-checkable CheckableGroup, reset the validation state when aria-invalid
    // is toggled to false from the parent component so that this won't be showing as invalid
    if (!isAriaInvalid) {
      setValidationState(null);
    }
  }, [isAriaInvalid, setValidationState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_ChipModule.default.root, _ChipModule.default["".concat(iconPosition, "Icon")], {
      [_ChipModule.default.containsError]: !isValid
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    "data-test": testAttrRoot,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
      ref: ref,
      id: id,
      className: (0, _cnbuilder.cnb)(_ChipModule.default.item, classNameItem),
      "data-test": testAttrItem,
      type: "checkbox",
      name: name,
      defaultChecked: defaultChecked,
      checked: checked,
      value: value,
      disabled: disabled,
      required: required,
      onChange: onChanged,
      onInvalid: onInvalidCallback
    }, rest)), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_ChipModule.default.container, classNameContainer),
      "data-test": testAttrContainer,
      children: [icon && /*#__PURE__*/(0, _react.cloneElement)(icon, {
        className: (0, _cnbuilder.cnb)(_ChipModule.default.icon, _ChipModule.default.iconDisplay, classNameIcon),
        'data-test': testAttrIcon
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _ChipModule.default.row,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          htmlFor: id,
          className: (0, _cnbuilder.cnb)(_ChipModule.default.label, classNameLabel),
          "data-test": testAttrLabel,
          children: label
        }), showDismiss && /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeDefault.default, {
          className: (0, _cnbuilder.cnb)(_ChipModule.default.icon, _ChipModule.default.iconDismiss, classNameDismiss),
          "data-test": testAttrDismiss
        })]
      })]
    })]
  }));
};
Chip.defaultProps = {
  testAttrRoot: 'chip-root',
  testAttrItem: 'chip-item',
  testAttrContainer: 'chip-container',
  testAttrLabel: 'chip-label',
  testAttrIcon: 'chip-icon',
  testAttrDismiss: 'chip-dismiss',
  value: 'on',
  iconPosition: 'left'
};
var _default = exports.default = Chip;